import * as Sentry from '@sentry/react';

import { getUniversalEnv } from 'app/lib/get-universal-env';

const nodeEnv = getUniversalEnv('NODE_ENV');

export const isUserAgentDisabled = () => {
  const userAgent = window?.navigator?.userAgent || '';
  const stingWithDisallowedBrowsers = getUniversalEnv('SENTRY_DISALLOWED_BROWSERS');
  const disallowedBrowsers = stingWithDisallowedBrowsers && stingWithDisallowedBrowsers.split(', ') || [];
  const userAgentIncludeDisallowedBrowser = disallowedBrowsers.length > 0
    && disallowedBrowsers.some((disallowedBrowser) => {
      return userAgent.includes(disallowedBrowser);
    });

  return userAgentIncludeDisallowedBrowser;
};

const sentryDisabledByUserAgent = typeof window !== 'undefined' && isUserAgentDisabled();

const getSentryEnabled = () => {
  if (nodeEnv === 'development' || sentryDisabledByUserAgent) {
    return false;
  }

  return true;
};

const sentryEnabled = process.env.SENTRY_CLIENT_ENABLED !== 'false' && getSentryEnabled();

if (!sentryEnabled) {
  Sentry.init({ enabled: false });
}

const dsn = getUniversalEnv('SENTRY_DSN');

if (sentryEnabled && dsn) {
  const appReleaseName = `${process.env.SENTRY_PROJECT}@${process.env.SEM_VER}`;
  const config = {
    dsn,
    environment: nodeEnv,
    release: appReleaseName,
    // https://github.com/getsentry/sentry/issues/12676
    ignoreErrors: ['Failed to fetch', 'Connection disconnected', 'Network request failed', 'NetworkError', 'withrealtime/messaging'],
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: Number(process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE) || 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: Number(process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) || 0.1,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.breadcrumbsIntegration({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        xhr: true,
      }),
      Sentry.globalHandlersIntegration({
        onerror: true,
        onunhandledrejection: true,
      }),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        mask: ['[type="password"]'],
      }),
    ],
    sampleRate: Number(process.env.SENTRY_CLIENT_SAMPLE_RATE) || 0.1,
    tracesSampleRate: Number(process.env.SENTRY_CLIENT_TRACES_SAMPLE_RATE) || 0.1,
    normalizeDepth: 5,
  };

  Sentry.init(config);
}

export const SentryConfigured = Sentry;
